export function defaultPasswordGenerate(firstName) {
  if (!firstName || typeof firstName !== "string") {
    throw new Error("First name must be a non-empty string");
  }

  // Normalize: trim and capitalize first letter
  const normalized = firstName.trim();
  const capitalized =
    normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();

  let suffix = "123";

  // Ensure minimum 8 characters in total
  const minLength = 8;
  let basePassword = `${capitalized}@${suffix}`;

  if (basePassword.length < minLength) {
    // Add extra digits until length >= 8
    let extra = 4; // start from 4 since suffix is "123"
    while (`${capitalized}@${suffix}`.length < minLength) {
      suffix += extra;
      extra++;
    }
    basePassword = `${capitalized}@${suffix}`;
  }

  return basePassword;
}

// // ✅ Usage examples
// console.log(defaultPasswordGenerate("amit"));   // Amit@123
// console.log(defaultPasswordGenerate("AMIT"));   // Amit@123
// console.log(defaultPasswordGenerate("aMiT"));   // Amit@123
// console.log(defaultPasswordGenerate("Al"));     // Al@12345 (8 chars)
